import type { FaireProductEntity } from "../../entity_types/product";

export const p_76kwqwu589: FaireProductEntity = {
  token: "p_76kwqwu589",
  type: "product",
  name: "Pecan Praline",
  brandToken: "b_xtvv45q74f",
  brandName: "Meem's Fudge Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/e601ce4472942bb99e45406c9d95e10c8f41d84bfd530667f9bfd60ae49a0340.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fe8f6e7352dfffe4b66903642142d6896a7f7f2e3c1c15d68d37a3857b02f2de.png",
    "https://cdn.faire.com/fastly/3c213a32054b076d4d6f2298f3b53de5af9444e087ccbe50497ddd4702ed6a13.png",
    "https://cdn.faire.com/fastly/3af06933bde54ba48544a7cf98228817bb014a2742bb4363e85a8396825d03a7.png",
  ],
  priceDollars: 4.5,
  description:
    "We start with our silky-smooth white chocolate fudge and add in a touch of praline flavor and then swirl in gourmet pecan praline from another one of our local partners, and female owned business, Lakeside Confectionary. It's all 100% handmade, small batch and ohhh so gooey yuuuummy!!!\n",
  tags: [],
  msrpDollars: 9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:49.132Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
